/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode } from "react";
import containerFullWidthStyle from "./containerFullWidthStyle";
import Container from "./Container";
import { Box } from "@mui/material";
import { SxProps } from "@mui/system";

type ContainerFullWidthProps = {
  children?: ReactNode;
  sectionPadding?: boolean;
  backgroundColor?: "primary" | "grey";
  sx?: SxProps;
};

/* TODO: Dont use it anymore in redesign use Container variant "full" instead, should be removed after redesign  */
const ContainerFullWidth = ({ children, sectionPadding = true, backgroundColor, sx = [] }: ContainerFullWidthProps) => {
  const sectionPaddingClass = sectionPadding ? "section" : "noSection";
  return (
    <Box
      sx={[containerFullWidthStyle.sectionContainer, containerFullWidthStyle, containerFullWidthStyle[sectionPaddingClass], ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <Box sx={backgroundColor ? containerFullWidthStyle[backgroundColor] : undefined}>
        <Container sx={containerFullWidthStyle.innerSectionContainer}>{children}</Container>
      </Box>
    </Box>
  );
};

export default ContainerFullWidth;
